import { render, staticRenderFns } from "./Form15Table.vue?vue&type=template&id=0a0ce5da"
import script from "./Form15Table.vue?vue&type=script&lang=ts"
export * from "./Form15Table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports